/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ivory_Clear_Ram_PlanInputs */

const en_ivory_clear_ram_plan = /** @type {(inputs: Ivory_Clear_Ram_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const de_ivory_clear_ram_plan = /** @type {(inputs: Ivory_Clear_Ram_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Ivory_Clear_Ram_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ivory_clear_ram_plan = /** @type {((inputs?: Ivory_Clear_Ram_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ivory_Clear_Ram_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ivory_clear_ram_plan(inputs)
	return de_ivory_clear_ram_plan(inputs)
});